import API from 'js/lib/api';

export default API('/api/productPrices.v3', {
  type: 'rest',
});
